export default __webpack_public_path__ + "static/tim-bitmoji-fc0aaf98b95e26297bf00b88979eb196.png";